import type { Alert } from "@/services/api/guardiansv2/types";

export interface AlertConversationScope {
  missionId: string | null;
  taskId: string | null;
}

/** Resolve mission/task scope for opening the conversation view from an alert. */
export function alertConversationScope(alert: Alert): AlertConversationScope {
  const missionId =
    alert.scope.mission_id ?? (alert.subject.type === "mission" ? alert.subject.id : null);
  const taskId =
    alert.scope.task_id ?? (alert.subject.type === "task" ? alert.subject.id : null);
  return { missionId, taskId };
}

/** @deprecated Use alertConversationScope + guardiansConversationUrl */
export function alertConversationParams(alert: Alert): Record<string, string | null> {
  const { missionId, taskId } = alertConversationScope(alert);

  if (missionId) {
    return {
      view: "conversation",
      conversation: missionId,
      mission: missionId,
      task: null,
      alert: null,
    };
  }
  if (taskId) {
    return {
      view: "conversation",
      conversation: taskId,
      mission: null,
      task: taskId,
      alert: null,
    };
  }
  return {
    view: "conversation",
    conversation: alert.subject.id,
    mission: null,
    task: null,
    alert: null,
  };
}
